import styled, { createGlobalStyle } from 'styled-components';

export const AddMemberBtnWrapper = styled.div`
  position: relative;
  margin-left: auto;
`;

export const AddMemberBtn = styled.button`
  padding: 8px 16px;
  border: 1px solid #228be6;
  border-radius: 4px;
  color: #228be6;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 300ms ease;

  &:hover {
    color: #fff;
    background-color: #228be6;
  }
`;

export const AddMemberModalWrapper = styled.div``;

export const AddMemberModalStyleSheet = createGlobalStyle`
    body {
      .add-member-modal {
        &-body {
          position: absolute;
          top: 0;
          right: 0;
          height: 100vh;
          border-radius: 0;
          width: 40%;
          box-shadow:
                  0 17px 17px -7px rgba(0, 0, 0, 0.04),
                  0 36px 28px -7px rgba(0, 0, 0, 0.1),
                  0 1px 3px 0 rgba(0, 0, 0, 0.05);

          h4 {
            font-size: 16px;
          }

          .toggler {
            font-size: 30px;
          }
        }
      }
    }
`;

export const FormInputRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;

  label,
  span {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &:nth-child(2n) {
    margin-left: 20px;
  }

  input {
    padding: 8px 12px;
    width: 100%;
    border: 1px solid #ced4da;
    border-radius: 4px;
    margin-top: 5px;
    font-size: 14px;
  }
`;

export const SaveMemberBtn = styled.button`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #228be6;
  margin-top: 20px;
  padding: 8px 12px;
  border-radius: 4px;
  color: #228be6;
  font-weight: 500;
  font-size: 14px;
  transition: all 300ms ease;

  &:hover {
    color: #fff;
    background-color: #228be6;
    span {
      border-color: #fff !important;
      margin-left: 7px;
    }
  }

  span {
    margin-left: 7px;
  }
`;
